import { type Ref, type RefObject, useImperativeHandle } from "react";

export function useMergedRef<E extends HTMLElement>(forwardedRef: Ref<E | null>, elRef: RefObject<E>) {
  useImperativeHandle(forwardedRef, () => elRef.current);
  return elRef;
}
